import { render, staticRenderFns } from "./StripeMsgs.vue?vue&type=template&id=16456204&"
import script from "./StripeMsgs.vue?vue&type=script&lang=js&"
export * from "./StripeMsgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports